
/** Importing firebase */
import dbRef from '../../firebase/firebaseInit'
import op from "../../js/apexCharts/chartOptions.js"

/** Imprort library */
var uId = require('uniqid')

const state = {

    /** Booleans */
    isLoading:false,
    dataLoaded:false,
    isDark:false,

    /** Objects */
    students:{},
    visitors:{},

    apStudGrowth:{series:[],chartOptions:op.studGrowth},
    apVisitGrowth:{series:[],chartOptions:op.visitGrowth},

    barOverview:{series:[],options:op.barOptions},

    recStudents:[],
    recVisitors:[],

    /** Arrays */
    sOverview:[],
    vOverview:[],

}

const getters = {

    isDark: (state) => state.isDark,

    allStudents: ( state ) => state.students,
    allVisitors: ( state ) => state.visitors,

    countTotalUser: (state) => Object.keys(state.students).length,
    countTotalVisitor: (state) => Object.keys(state.visitors).length,

    sOverview: ( state ) => state.sOverview,
    vOverview: ( state ) => state.vOverview,

    barOverview: (state) => state.barOverview,

    apStudGrowth:(state) => state.apStudGrowth,
    apVisitGrowth:(state) => state.apVisitGrowth,

    isLoading: (state) => state.isLoading,
    isDataLoaded: (state) => state.dataLoaded,

    tVisitedToday:(state) => state.sOverview.vToday+state.vOverview.vToday,
    tSignedToday:(state) => state.sOverview.sToday+state.vOverview.sToday,
    tVisitedWeek:(state) => state.sOverview.vWeek+state.vOverview.vWeek,
    tSignedWeek:(state) => state.sOverview.sWeek+state.vOverview.sWeek,

    recStudents:(state) => state.recStudents,
    recVisitors:(state) => state.recVisitors,
}

const actions = {
    reFreshDatas({commit}){
        extras.resetOverviews();
        actions.fetchStudents({commit});
        actions.fetchVisitors({commit})
        actions.fetchRecStudents({commit})
        actions.fetchRecVisitors({commit})
    },
    async fetchRecStudents({commit}){
        state.isLoading=true;
        const response = await dbRef.collection('Students').orderBy('LastVisited','desc').limit(5).get()
        let recStudents =  [];response.forEach( doc => recStudents.push(doc.data()))
        commit('fixLastVisited',{w:'S',data:recStudents})
    },
    async fetchRecVisitors({commit}){
        state.isLoading=true;
        const response = await dbRef.collection('UsageHistory').orderBy('last_visited','desc').limit(5).get()
        let recVisitors=[];response.forEach(doc=>{
            let data = doc.data()
            data.id = doc.id
            recVisitors.push(data)
        })
        commit('fixLastVisited',{w:'V',data:recVisitors})
    },
    async fetchStudents({commit}){
        state.isLoading=true;
        const response = await dbRef.collection('aStudents').doc('_2019').get()
        commit('initiateAnalysis',{data:response.data(),w:'S'})
    },
    async fetchVisitors({commit}){
        state.isLoading=true;
        const response = await dbRef.collection('aUsages').doc('_2019').get()
        commit('initiateAnalysis',{data:response.data(),w:'V'})
    }
}

const mutations = {
    changeTheme(state,dark){
        localStorage.isDark=dark
        state.isDark=dark
    },
    fetchTheme(state){
        let dark = localStorage.getItem('isDark')
        if( dark === 'undefined' || dark === 'false'){
            localStorage.isDark = false
            state.isDark = false
        }else{
            localStorage.isDark = true
            state.isDark = true
        }
    },
    fixLastVisited(state, obj ){
        let data = obj.data;
        if( obj.w==='S'){
            let sTableData = [];
            data.forEach( u => {
                u.lastVisited = extras.getHowAgoTextSec(u.LastVisited)
                sTableData.push({id:u.ID,name:u.Name,lts:u.Level+'-'+u.Term+'-'+u.Section,lastVisited:u.lastVisited})
            });state.recStudents=sTableData
        }else{
            let sTableData = [];
            data.forEach( u => {
                u.lastVisited = extras.getHowAgoTextSec(u.last_visited)
                sTableData.push({ip:u.ip,city:u.city,id:u.id,lastVisited:u.lastVisited})
            });state.recVisitors=sTableData
        }
    },
    initiateAnalysis:( state, res )=>{
        let data = res.data
        let w = res.w;
        /** Apexchart series data for students/visitors growth */
        let seriesData = extras.getSeriesData(data)

        /** is it students data or visitors data */
        if(w==="S"){
            extras.setStudents(data);
            /** setting students growth data */
            state.apStudGrowth.series = [{name:'Students',data:seriesData}]
            /** students overview data */
            let oData = extras.getStudentsOverview(data)
            state.sOverview = oData.overview
            /** series data for bar chart */
            state.barOverview.series.push({name:"Students",data:oData.series})
            /** stoping loading */
            state.isLoading=false
        }
        else if(w==='V'){
            extras.setVisitors(data);
            /** setting visitors growth data */
            state.apVisitGrowth.series = [{name:'Visitors',data:seriesData}]
            /** visitors overview data */
            let oData = extras.getStudentsOverview(data)
            state.vOverview = oData.overview
            /** series data for bar chart */
            state.barOverview.series.push({name:"Visitors",data:oData.series})
            /** stoping loading */
            state.isLoading=false
        }
        
    },
    exportStudents: (state) => extras.exportToJson(state.student),
    setStudOverview: ( state, students ) => {
        state.studOverview=[];
        let totalStud = Object.keys(students).length;
        let overview = extras.getStudentsOverview(students,'S')
        for( let key in overview ){let val = overview[key]
            if( key === 'vToday' )extras.pushOverviewObject('visited today',val,totalStud,'S')
            else if( key === 'vLastWeek' )extras.pushOverviewObject('visited in this Week',val,totalStud,'S')
            else if( key === 'vLastMonth' )extras.pushOverviewObject('visited in this Month',val,totalStud,'S')
            else if( key === 'vLastYear' )extras.pushOverviewObject('visited in this Year',val,totalStud,'S')
            else if( key === 'sToday' )extras.pushOverviewObject('signed today',val,totalStud,'S')
            else if( key === 'sLastWeek' )extras.pushOverviewObject('signed in this Week',val,totalStud,'S')
            else if( key === 'sLastMonth' )extras.pushOverviewObject('signed in this Month',val,totalStud,'S')
            else if( key === 'sLastYear' )extras.pushOverviewObject('signed in this Year',val,totalStud,'S')
        }
        state.isLoading = false
    },
    setVisitOverview: ( state, visitors ) => {
        state.visitOverview=[];let totalVisit = Object.keys(visitors).length;
        let overview = extras.getStudentsOverview(visitors)
        for( let key in overview ){let val = overview[key]
            if( key === 'vToday' )extras.pushOverviewObject('visited today',val,totalVisit,'V')
            else if( key === 'vLastWeek' )extras.pushOverviewObject('visited in this Week',val,totalVisit,'V')
            else if( key === 'vLastMonth' )extras.pushOverviewObject('visited in this Month',val,totalVisit,'V')
            else if( key === 'vLastYear' )extras.pushOverviewObject('visited in this Year',val,totalVisit,'V')
            else if( key === 'sToday' )extras.pushOverviewObject('added today',val,totalVisit,'V')
            else if( key === 'sLastWeek' )extras.pushOverviewObject('added in this Week',val,totalVisit,'V')
            else if( key === 'sLastMonth' )extras.pushOverviewObject('added in this Month',val,totalVisit,'V')
            else if( key === 'sLastYear' )extras.pushOverviewObject('added in this Year',val,totalVisit,'V')
        }
        state.isLoading = false
    }
}

const extras = {
    resetOverviews(){
        state.barOverview.series=[]
    },
    getHowAgoTextSec(lastV){
        let lvInSec = this.getHowAgoInSecond(lastV)
        if( lvInSec > 604800 ){
            let lvInDay = this.getHowAgoInDay(lastV)
            if( lvInDay === 365 ){
                return '1 year ago'
            }else if(lvInDay > 365){
                let year = Math.floor(lvInDay/365)
                let month = Math.floor((lvInDay%365)/30)
                return year+'y '+month+'m ago'
            }else if( lvInDay === 30 ){
                return "1 month ago"
            }else if( lvInDay > 30 ){
                let month = Math.floor(lvInDay/30)
                let day = lvInDay%30
                return month+'m '+day+'d ago'
            }else if( lvInDay === 7){
                return '1 week ago'
            }else{
                let week = lvInDay/7;
                let day = lvInDay%7
                return week+'w '+day+'d ago'
            }
        }else if( lvInSec === 86400 ){
            return '1 day ago'
        }else if( lvInSec > 86400 ){
            let day = Math.floor(lvInSec/86400);
            let hour = Math.round((lvInSec%86400)/3600)
            return day+'d '+hour+'h ago'
        }else if( lvInSec === 3600 ){
            return 'a hour ago'
        }else if( lvInSec > 3600 ){
            let hour = Math.floor(lvInSec/3600)
            let min = Math.round((lvInSec%3600)/60)
            return hour+'h '+min+'m ago'
        }else if( lvInSec === 60 ){
            return '1 minute ago'
        }else if( lvInSec > 60 ){
            let min = Math.floor(lvInSec/60)
            let sec = lvInSec%60
            return min+ 'm '+sec+'sec ago'
        }else{
            return lvInSec+' sec ago'
        }
    },
    getSeriesData(data){
        let s = [];for (let i=0;i<30;i++)s.push(0)
        s[s.length-1] = Object.keys(data).length
        for (let index = 1; index < s.length; index++) {
            let dt = new Date(new Date().toLocaleDateString());
            //let dt = new Date();
            dt.setDate(dt.getDate()-(index-1));
            let counter=0;for(let id in data){
            let uLVinMS=data[id].createdAt.seconds*1000
            let d=dt.getTime();if(uLVinMS<=d)counter++}s[(s.length-1)-index]=counter
        }
        return s;
    },
    setStudents(students){state.students = students},
    setVisitors(visitors){state.visitors = visitors},
    pushOverviewObject(a, b, c, d){
        if( d === 'S' )state.studOverview.push({id:uId(),title:a.toUpperCase(),value:b,percentange:Math.round((b/c)*100)})
        else if( d=== 'V' )state.visitOverview.push({id:uId(),title:a.toUpperCase(),value:b,percentange:Math.round((b/c)*100)})
    },
    exportToJson(jsonData){
        let dataStr = JSON.stringify(jsonData);
        let dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);    
        let exportFileDefaultName = 'data.json';    
        let linkElement = document.createElement('a');
        linkElement.setAttribute('href', dataUri);
        linkElement.setAttribute('download', exportFileDefaultName);
        linkElement.click();
    },
    getHowAgoInSecond(lastTS ){
        return Math.ceil(Math.abs(new Date().getTime()-(lastTS.seconds*1000))/1000)
    },
    getHowAgoInMinute(lastTS ){
        let today = new Date(new Date().toLocaleDateString())
        return Math.ceil(Math.abs((lastTS.seconds*1000)-today.getTime())/6e4)
    },
    getHowAgoInDay(lastTS ){
        let today = new Date(new Date().toLocaleDateString())
        return Math.ceil(Math.abs((lastTS.seconds*1000)-today.getTime())/(6e4*60*24))
    },
    getHowAgoFromNowInDay(lastTS){
        let today = new Date(new Date().toLocaleDateString())
        return Math.ceil(Math.abs(today.getTime()-(lastTS.seconds*1000))/(6e4*60*24))
    },
    getStudentsOverview(students){
        let sOV = {vToday:0,sToday:0,vWeek:0,sWeek:0}
        let series = [0,0,0,0]

        for( let id in students){
            /** Getting visited / signed howLong from now */
            let v_howAgo = this.getHowAgoInDay(students[id].lastVisited)
            let s_howAgo = this.getHowAgoInDay(students[id].createdAt)

            /** Count How many visited how ago */
            if( v_howAgo <= 1) sOV.vToday++
            if( v_howAgo <= 7) sOV.vWeek++
            if( v_howAgo <= 30) series[0]++
            if( v_howAgo <= 365) series[1]++

            /** Count How many signed how ago */
            if( s_howAgo <= 1) sOV.sToday++
            if( s_howAgo <= 7) sOV.sWeek++
            if( s_howAgo <= 30) series[2]++
            if( s_howAgo <= 365) series[3]++
        }
        return {overview:sOV,series:series}
    }
}

export default {
    state,getters,actions,mutations
}